/**
 * Registration statuses that still need an admin to look at the device.
 * Mirrors UNVERIFIED_REGISTRATION_STATUSES in server/api/server/models/device.py.
 */
export const UNVERIFIED_REGISTRATION_STATUSES = [
  'pending',
  'enrolled',
  'unverified_suspicious',
] as const;

/** The same set as the comma-separated value GET /api/v1/devices/ expects. */
export const UNVERIFIED_REGISTRATION_STATUS_PARAM = UNVERIFIED_REGISTRATION_STATUSES.join(',');
